<template>
	<div class="col-12 mt-3 pl-0 pr-0" id="partner-us">
		<div class="col-12 pl-0 pr-0 pl-md-3 pr-md-3 color-black text-center font-size-14 font-size-sm-11 font-weight-bold pt-3 pb-3 d-flex">
			<div class="col-6 col-md-4 offset-md-2 pl-0 pr-0 pl-md-3 pr-md-3" :class="recommend == true ? 'border-bottom border-mila border-bot-5' : 'color-gray'" @click="recommendTrue">
				<span class="cursor-pointer">Rekomendasi Produk</span>
			</div>
			<div class="col-6 col-md-4 pl-0 pr-0 pl-md-3 pr-md-3" @click="lastTrue" :class="last == true ? 'border-bottom border-mila border-bot-5' : 'color-gray' ">
				<span class="cursor-pointer">Terakhir Dilihat</span>
			</div>
		</div>
		<div class="col-12 pl-0 pr-0 pt-md-3 pb-3" v-if="recommend">
			<carousel v-if="recomendedProduct.length > 0"  ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0 pt-2 pb-2" :responsive="{0:{items:1},600:{items:2},1000:{items:3}}" :margin="20" :autoplay="false" :nav="false" :loop="false" :dots="false">
				<div class="col-12 background-white rounded hov-cus-shadow pt-3 pb-3 mb-2 mr-2" v-for="(product, index) in recomendedProduct" :key="index">
					<div class="col-12 d-flex pl-0 pr-0 box-product">
						<div class="col-6 pl-0">
							<img :src="product.product_image_filename" class="img-fluid rounded" alt="">
						</div>
						<div class="col-6 pl-0 pr-0">
							<div class="color-mila font-weight-bold font-size-sm-11 font-size-13">{{ product.product_name }}</div>
							<div class="color-purple font-size-sm-10 font-size-12 f-lato">Rp {{ product.product_price | toNumber }} / {{ product.product_unit }}</div>
							<div class="color-gray font-size-10 f-lato">{{ product.product_weight | toKg }}</div>
							<div class="color-black font-size-sm-9 font-size-10 pt-2">{{ product.product_description.slice(0, 60) }}...</div>
						</div>
					</div>
					<div class="col-12 mt-3 pl-0 pr-0 pt-0">
						<router-link :to="{ name: 'product', params: { code: product.product_code }}" class="col-12 btn rounded background-button-template no-box-shadow color-white">
							<span class="font-size-sm-9 font-size-11">Detail Produk</span>
						</router-link>
					</div>
				</div>
			</carousel>
			<carousel v-show="recomendedProduct.length == 0" ref="carousel3" id="owl-menu3" class="col-12 pl-0 pr-0 pt-2 pb-2" :responsive="{0:{items:1},600:{items:2},1000:{items:3}}" :margin="20" :autoplay="true" :nav="false" :loop="false" :dots="true">
				<SkeletonProduct class="col-12 background-white rounded hov-cus-shadow pt-3 pb-3 mb-2 mr-2" v-for="index in 3" :key="'skl-product'+index"/>
			</carousel>
		</div>
		<div class="col-12 pl-0 pr-0 pt-md-3 pb-3" v-if="last">
			<carousel v-if="recomendedProduct.length > 0" ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0 pt-2 pb-2" :responsive="{0:{items:1},600:{items:2},1000:{items:3}}" :margin="20" :autoplay="false" :nav="false" :loop="false" :dots="false">
				<div class="col-12 background-white rounded hov-cus-shadow pt-3 pb-3 mb-2 mr-2" v-for="(product, index) in recomendedProduct" :key="index">
					<div class="col-12 d-flex pl-0 pr-0 box-product">
						<div class="col-6 pl-0">
							<img :src="product.product_image_filename" class="img-fluid rounded" alt="">
						</div>
						<div class="col-6 pl-0 pr-0">
							<div class="color-mila font-weight-bold font-size-sm-11 font-size-13">{{ product.product_name }}</div>
							<div class="color-purple font-size-sm-10 font-size-12 f-lato">Rp {{ product.product_price | toNumber }} / {{ product.product_unit }}</div>
							<div class="color-gray font-size-10 f-lato">{{ product.product_weight | toKg }}</div>
							<div class="color-black font-size-sm-9 font-size-10 pt-2">{{ product.product_description.slice(0, 60) }}...</div>
						</div>
					</div>
					<div class="col-12 mt-3 pl-0 pr-0 pt-0">
						<router-link :to="{ name: 'product', params: { code: product.product_code }}" class="col-12 btn rounded background-button-template no-box-shadow color-white">
							<span class="font-size-sm-9 font-size-11">Detail Produk</span>
						</router-link>
					</div>
				</div>
			</carousel>
			<carousel v-show="recomendedProduct.length == 0" ref="carousel3" id="owl-menu3" class="col-12 pl-0 pr-0 pt-2 pb-2" :responsive="{0:{items:1},600:{items:2},1000:{items:3}}" :margin="20" :autoplay="true" :nav="false" :loop="false" :dots="true">
				<SkeletonProduct class="col-12 background-white rounded hov-cus-shadow pt-3 pb-3 mb-2 mr-2" v-for="index in 3" :key="'skl-product'+index"/>
			</carousel>
		</div>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel';
import { mapState, mapActions } from 'vuex';
import SkeletonProduct from '@/components/Skeleton/SkeletonProduct';

export default {
	name: 'LastSeen',
	components: {
		carousel, SkeletonProduct
	},
	computed:{
		...mapState('product', ['recomendedProduct']),
	},
	data(){
		return {
			recommend: true,
			last: false
		}
	},
	methods: {
		...mapActions('product', ['getRecomendedProduct']),

		recommendTrue() {
			this.recommend = true
			this.last = false
		},
		lastTrue() {
			this.recommend = false
			this.last = true
		}
	},
	created(){
		this.getRecomendedProduct();
	}
}
</script>

<style>

</style>